import React, { createContext, useReducer } from 'react';

export const CarouselContext = createContext(null);

export const CarouselProvider = ({ children, totalSlides }) => {
  const initialState = {
    prevIndex: 0,
    currentIndex: 0,
    totalSlides,
    direction: 'right',
  };

  function reducer(state, action) {
    if (process.env.NODE_ENV === 'development') {
      console.info(action);
    }

    const { currentIndex, totalSlides } = state;

    switch (action.type) {
      case 'NEXT_SLIDE':
        return {
          ...state,
          prevIndex: state.currentIndex,
          currentIndex: currentIndex === totalSlides - 1 ? 0 : currentIndex + 1,
          direction: 'right',
        };
      case 'PREV_SLIDE':
        return {
          ...state,
          prevIndex: state.currentIndex,
          currentIndex: currentIndex === 0 ? totalSlides - 1 : currentIndex - 1,
          direction: 'left',
        };
      case 'GOTO_SLIDE':
        return {
          ...state,
          prevIndex: state.currentIndex,
          currentIndex: action.index,
          direction: 'right',
        };
      case 'SET_HEIGHT':
        return {
          ...state,
          height: action.height,
        };
      default:
        return state;
    }
  }

  const [ state, dispatch ] = useReducer(reducer, initialState);

  return (
    <CarouselContext.Provider value={{ state, dispatch }}>
      {children}
    </CarouselContext.Provider>
  );
};
